import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';

// Корпоративный портал «Упряжка» — точка монтирования React-приложения.

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Корневой элемент #root не найден в index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
